import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { MVisionAppClient } from '../store/mvision-client-list';
import { setCurrentAppClient, StoreState } from '../store/reducers';
import { getCurrentAppClient, selectAnyUnsavedChangesInApp } from '../store/selectors';
import Select, { createFilter } from 'react-select';

import './client-selector.css';

const ClientSelector = (props: { clientList: MVisionAppClient[] }) => {

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const currentAppClient = useSelector(getCurrentAppClient);
    const anyUnsavedChanges = useSelector(selectAnyUnsavedChangesInApp);
    const isClientDataOperationInProgress = useSelector((state: StoreState) => state.isFetchingClientData || state.isModelCustomizationDeleteInProgress);

    const changeAppClient = (newAppClientId: string) => {
        if (newAppClientId !== currentAppClient?.userId) {
            const newValue = newAppClientId === '' ? undefined : newAppClientId;

            // prompt user to confirm if there are unsaved changes
            if (newValue !== currentAppClient?.userId && anyUnsavedChanges && !window.confirm(t('confirm.changeConfigurationTarget') as string)) {
                return;
            }

            dispatch(setCurrentAppClient(newValue));
        }
    }

    const dropdownValues: (MVisionAppClient | { userId: undefined, userName: string })[] = [];
    props.clientList.forEach(cl => dropdownValues.push(cl));

    const clientOptions = dropdownValues.map(dV => ({ value: dV.userId, label: dV.userName }));

    const selectedOption = currentAppClient ? clientOptions.find(co => co.value === currentAppClient.userId) : undefined;

    return (
        <div className="client-selector">
            <div className="client-selector-label">{t('topMenu.configurationTarget')}</div>
                { 
                    dropdownValues.length > 0 &&
                    <Select
                        id="app-client-selector-form"
                        name="app-client-selector-form"
                        className='client-selector-dropdown'
                        isDisabled={isClientDataOperationInProgress}
                        onChange={(newAppClient) => newAppClient && changeAppClient(newAppClient.value || '')}
                        value={selectedOption}
                        options={clientOptions}
                        filterOption={createFilter({ ignoreCase: true })}
                        placeholder={t('selectConfigurationTarget.placeholder')}
                        maxMenuHeight={700}
                    />
                }
        </div>
    );
}

export default ClientSelector;
